import { PsychologistProfile, TimeSlot } from "@/types/schedule";

export const formatPsychologistData = (data: any): PsychologistProfile => {
  if (!data) {
    return {
      id: '',
      name: 'Psicólogo não encontrado',
      photoUrl: '',
      specialties: [],
      languages: [],
      price: 0,
      rating: 0,
      bio: '',
      status: 'pending'
    };
  }

  return {
    id: data.id || '',
    name: data.name || 'Nome não informado',
    photoUrl: data.photo_url || data.photoUrl || '',
    specialties: Array.isArray(data.specialties) ? data.specialties : 
                data.specialties ? [data.specialties] : [],
    languages: Array.isArray(data.languages) ? data.languages : 
               data.languages ? [data.languages] : ['Português'],
    price: data.price || 150,
    price_30: data.price_30,
    price_45: data.price_45,
    price_60: data.price_60,
    rating: data.rating || 4.8,
    bio: data.bio || data.short_bio || '',
    shortBio: data.short_bio,
    education: data.education,
    experience: data.experience,
    approach: data.approach,
    therapeuticApproach: data.therapeutic_approach,
    certifications: data.certifications,
    personalStatement: data.personal_statement,
    crp: data.crp,
    university: data.university,
    graduationYear: data.graduation_year,
    documents: data.documents,
    status: data.status || 'pending',
    registrationDate: data.created_at,
    termsAccepted: data.terms_accepted,
    pixKey: data.pix_key
  };
};

export const formatPsychologistsData = (data: any[]): PsychologistProfile[] => {
  if (!Array.isArray(data)) {
    return [];
  }
  
  return data.map(formatPsychologistData);
};

export const formatDurationOptions = (psychologist: PsychologistProfile) => {
  const options = [];
  
  if (psychologist.price_30) {
    options.push({
      duration: 30,
      label: '30 minutos',
      price: psychologist.price_30
    });
  }
  
  if (psychologist.price_45) {
    options.push({
      duration: 45,
      label: '45 minutos',
      price: psychologist.price_45
    });
  }
  
  if (psychologist.price_60 || psychologist.price) {
    options.push({
      duration: 60,
      label: '60 minutos',
      price: psychologist.price_60 || psychologist.price
    });
  }
  
  // Se não houver preços específicos, usar preço padrão
  if (options.length === 0) {
    options.push({
      duration: 60,
      label: '60 minutos',
      price: psychologist.price || 150
    });
  }
  
  return options;
};

// Função legacy mantida para compatibilidade, mas agora retorna array vazio
// A lógica real está em availabilityUtils.ts
export const generateTimeSlots = (): TimeSlot[] => {
  return [];
};
